import { render, staticRenderFns } from "./Designated-page.vue?vue&type=template&id=bd315d2a&scoped=true"
import script from "./Designated-page.vue?vue&type=script&lang=js"
export * from "./Designated-page.vue?vue&type=script&lang=js"
import style0 from "./Designated-page.vue?vue&type=style&index=0&id=bd315d2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd315d2a",
  null
  
)

export default component.exports